import AppContext, { ProductContext } from 'context/Context';
import { useContext } from 'react';
import y from 'y4/Utils';
import { postToTask } from 'y4/Y4Api';
import { useTranslation } from 'react-i18next';

const useAddressHook = () => {
  const { t } = useTranslation('commerce');

  const {
    config: { corp }
  } = useContext(AppContext);

  const { productsDispatch } = useContext(ProductContext);
  /**
   * Show add address modal dialog
   */
  const handleNewAddressClick = () => {
    productsDispatch({
      type: 'TOGGLE_ADDRESS_MODAL',
      payload: {
        type: 'add',
        address: { name: '', phone: '', address: '' } //create new address
      }
    });
  };

  /**
   * Show edit address modal dialog
   */
  const handleEditAddressClick = address => {
    productsDispatch({
      type: 'TOGGLE_ADDRESS_MODAL',
      payload: {
        type: 'edit',
        address: address
      }
    });
  };

  /**
   * Change address fields
   * @param {*} address
   */
  const handleAddressChanged = address => {
    productsDispatch({
      type: 'ADDRESS_MODAL_CHANGE',
      payload: {
        address
      }
    });
  };

  /**
   * Add or update address
   * @param {*} address
   */
  const saveAddress = (address, type) => {
    postData('TASK_ECommerce_Save_Address', address).then(rt => {
      if (rt.isOk()) {
        //Close addres modal dialog
        productsDispatch({
          type: 'TOGGLE_ADDRESS_MODAL'
        });
        if (type == 'add') {
          productsDispatch({
            type: 'ADD_TO_ADDRESS',
            payload: {
              address: address
            }
          });
        } else if (type == 'edit') {
          productsDispatch({
            type: 'UPDATE_ADDRESS_ITEM',
            payload: {
              address: address
            }
          });
        }
      } else {
        y.toastError(rt.message);
      }
    });
  };

  /**
   * To delete address: first confirm then call api delete from database then remove from ui
   */
  const handleDeleteAddressClick = address => {
    y.modal.confirm(
      t('Delete confirmation'),
      null,
      y.formatByArgs(
        t('Do you want to delete the shipping address: {0}?'),
        address.name
      ),
      t('Delete'),
      () => {
        //call api
        postData('TASK_ECommerce_Delete_Address', { id: address.id }).then(
          rt => {
            if (rt.isOk()) {
              productsDispatch({
                type: 'REMOVE_ADDRESS',
                payload: {
                  address: address
                }
              });
            } else {
              y.toastSuccess(rt.message);
            }
          }
        );
      }
    );
  };

  const loadAddresses = () => {
    postData('TASK_ECommerce_Load_Address_List').then(rt => {
      if (rt.isOk()) {
        productsDispatch({
          type: 'INIT_ADDRESSES',
          payload: { addresses: rt.data.rows }
        });
      } else {
        y.toastError(rt.message);
      }
    });
  };

  /**
   * Load data from back end
   * @param {*} action
   */
  const postData = (task, params = {}) => {
    return postToTask(task, { ...params, corp });
  };

  return {
    loadAddresses,
    saveAddress,
    handleNewAddressClick,
    handleAddressChanged,
    handleEditAddressClick,
    handleDeleteAddressClick
  };
};

export default useAddressHook;
